<div class="upload-test-result-modal">
  <div class="modal-header">
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="handleModalHide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="info">
      <h3>{{ title }}</h3>
      <h4>{{ subtitle }}</h4>
      <ng-content></ng-content>
      <input
        (change)="onFileUploaded($event)"
        class="custom-file-input"
        id="files"
        name="files"
        lang="en"
        type="file"
        [disabled]="!isUploadable"
        multiple
        [accept]="acceptedFileTypes"
      />
      <label class="form-control-label black-text m-0">Files</label>
      <label for="files" class="label-files">
        <img src="../../../../assets/upload-icon.png" alt="Upload Icon" />
        <p *ngIf="isUploadable">
          {{ test?.resultPath ? "Replace Files" : "Upload Files" }}
        </p>
        <p *ngIf="!isUploadable" class="text-danger">
          This file was uploaded from the app - You can not replace it!
        </p>
      </label>
      <p class="files-count">
        {{ filesCount }} File{{ filesCount != 1 ? "s" : "" }} Uploaded
      </p>
      <ul *ngIf="uploadedFiles?.length" class="uploaded-files">
        <li *ngFor="let file of uploadedFiles; let i = index">
          <div class="file-info">
            <p class="filename">{{ file.name }}</p>
            <p class="file-size">
              {{ file.size / (1024 * 1024) | number : "1.2-3" }}MB
            </p>
          </div>
          <div class="file-action">
            <button
              placement="top"
              tooltip="Delete Test Result"
              (click)="onDeleteFile(i)"
            >
              <span class="btn-inner--icon">
                <i class="fa fa-trash"> </i>
              </span>
            </button>
          </div>
        </li>
      </ul>
      <ul *ngIf="filesExisted" class="uploaded-files">
        <li *ngFor="let file of filesExisted; let i = index">
          <div class="file-info">
            <p class="filename">{{ file.path.split("/").pop() }}</p>
          </div>
          <div *ngIf="file.isEditable" class="file-action">
            <button
              placement="top"
              tooltip="Delete File"
              (click)="onDeleteExistedFile(file, i)"
            >
              <span class="btn-inner--icon">
                <i class="fa fa-trash"> </i>
              </span>
            </button>
          </div>
        </li>
      </ul>
    </div>
    <div class="actions">
      <button
        class="btn save-btn"
        (click)="onUploadFiles()"
        [disabled]="(!uploadedFiles.length || !isOkayToSubmit) && !isUpdate"
      >
        Save
      </button>
    </div>
  </div>
</div>
